// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCFpAujMkexAxIB9cuztMa_EV9FU1NuOGQ",
  authDomain: "kshopping-c5fd6.firebaseapp.com",
  projectId: "kshopping-c5fd6",
  storageBucket: "kshopping-c5fd6.firebasestorage.app",
  messagingSenderId: "76124189957",
  appId: "1:76124189957:web:ead3ba4c9a2d5f98dd736c",
  measurementId: "G-T8Q4VT5JR4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firestore and Auth
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;